export default __webpack_public_path__ + "static/media/bridge-users.12eed235.svg";